module.exports = __webpack_public_path__ + "static/media/predictor-maintenance-logo.e010092c.svg";